import { StatsMessage, StatsTextMessage } from '../../../model/StatsAssistant'

export type UserTurn = {
  type: 'user'
  message: StatsMessage
}

export type AssistantTurn = {
  type: 'assistant'
  messages: StatsMessage[]
}

export type ConversationTurn = UserTurn | AssistantTurn

export const groupMessagesIntoTurns = (messages: StatsMessage[]): ConversationTurn[] => {
  const turns: ConversationTurn[] = []
  let assistantBatch: StatsMessage[] = []

  const flushAssistant = (): void => {
    if (assistantBatch.length === 0) return
    turns.push({ type: 'assistant', messages: assistantBatch })
    assistantBatch = []
  }

  for (const message of messages) {
    if (message.role === 'user') {
      flushAssistant()
      turns.push({ type: 'user', message })
      continue
    }
    assistantBatch.push(message)
  }

  flushAssistant()
  return turns
}

export const findLastUserMessage = (messages: StatsMessage[]): StatsTextMessage | null => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index]
    if (message.role === 'user' && message.type === 'text') {
      return message
    }
  }
  return null
}

export const hasMessagesAfter = (messages: StatsMessage[], ulid: string): boolean => {
  const index = messages.findIndex((message) => message.ulid === ulid)
  return index >= 0 && index < messages.length - 1
}
